// extracted by mini-css-extract-plugin
export default {"wrapper":"pageNotFound_wrapper__wIBtq","wrapper_header":"pageNotFound_wrapper_header__2iWqk"};